import { rgApi } from "@/lib/rgApi";
import FormBlock from "./FormBlock";

/**
 * FormActionsBlock — expériences avec formulaire voyageur : bain fleuri & couchage
 * du 3ᵉ voyageur. Présentés via le bloc harmonisé FormBlock, exactement comme le
 * petit-déjeuner (icône + nom, statut, Envoyer sur WhatsApp / SMS / Copier / Prévisualiser).
 *
 * Chaque lien passe par son wrapper d'aperçu WhatsApp dédié (photo + titre propres) :
 *   • bain fleuri → /api/rg/ba/{token} → /bain-fleuri/{token}
 *   • couchage    → /api/rg/co/{token} → /couchage/{token}
 * Les réponses (confirmation précautions / choix de couchage) se rattachent
 * automatiquement à la BONNE réservation et font passer le statut à « Réponse reçue ».
 */

const FALLBACK = {
  form_couchage: "Bonjour {first_name} 🌿\nPour préparer au mieux votre arrivée, pourriez-vous m'indiquer votre choix de couchage pour le 3ᵉ voyageur via ce petit lien ?\n{lien}\nMerci beaucoup et à très vite ✨",
  form_bain_fleurs: "Bonjour {first_name} 🌸\nVotre bain de fleurs sera préparé avec des fleurs fraîches soigneusement sélectionnées. Avant d'en profiter, merci de prendre connaissance de quelques précautions via ce petit lien, puis de confirmer que vous en avez pris connaissance 🙏\n{lien}\nÀ très vite ✨",
};

const COUCHAGE_LABELS = {
  lit_parapluie: "Lit parapluie",
  canape_deploye: "Canapé dépliant · Déployé à l'arrivée",
  canape_plie: "Canapé dépliant · Plié à l'arrivée",
};

export default function FormActionsBlock({ reservation: r, templates = {}, onPatch, onLog, needsCouchage, hasBain, busy }) {
  const fs = r.form_status || {};
  if (!needsCouchage && !hasBain) return null;

  const firstName = (r.name || "").trim().split(/\s+/)[0] || "";
  const msgFor = (key, link) => {
    const raw = templates[key] || FALLBACK[key] || "";
    return raw.replace(/\{first_name\}/g, firstName).replace(/\{lien\}/g, link).trim();
  };
  const setStatus = (key, value) => {
    const next = { ...fs };
    if (value === null) delete next[key];
    else next[key] = value;
    onPatch({ form_status: next });
  };

  const bainState = fs.bain_fleurs === "received" ? "received" : fs.bain_fleurs === "sent" ? "sent" : "to_send";
  const couchageState = fs.couchage === "received" ? "received" : fs.couchage === "sent" ? "sent" : "to_send";
  const couchageLabel = COUCHAGE_LABELS[fs.couchage_choice];

  return (
    <>
      {hasBain && (
        <FormBlock
          icon="🌸"
          title="Bain fleuri"
          subtitle="Envoie les précautions ; le voyageur confirme « j'ai pris connaissance ». Le statut passe à « Réponse reçue » automatiquement."
          anchorId="bain-fleuri"
          testid="rg-bain"
          state={bainState}
          phone={r.phone}
          busy={busy}
          fetchToken={() => rgApi.getBainLink(r.id).then((res) => res.token)}
          wrapperPath="ba"
          previewPath="bain-fleuri"
          buildMessage={(link) => msgFor("form_bain_fleurs", link)}
          onSent={(channel, msg) => { if (onLog) onLog(channel, msg); if (bainState !== "received") setStatus("bain_fleurs", "sent"); }}
          onCancel={() => setStatus("bain_fleurs", null)}
          onReopen={() => setStatus("bain_fleurs", "sent")}
          receivedNode={<p className="rg-tiny" style={{ margin: 0, color: "#2f7a43" }}>Précautions confirmées par le voyageur ✅</p>}
        />
      )}

      {needsCouchage && (
        <FormBlock
          icon="🛏️"
          title="Couchage 3ᵉ voyageur"
          subtitle="Envoie le lien ; le voyageur indique son choix de couchage. Le statut passe à « Réponse reçue » automatiquement."
          anchorId="troisieme-lit"
          testid="rg-couchage"
          state={couchageState}
          phone={r.phone}
          busy={busy}
          fetchToken={() => rgApi.getCouchageLink(r.id).then((res) => res.token)}
          wrapperPath="co"
          previewPath="couchage"
          buildMessage={(link) => msgFor("form_couchage", link)}
          onSent={(channel, msg) => { if (onLog) onLog(channel, msg); if (couchageState !== "received") setStatus("couchage", "sent"); }}
          onCancel={() => setStatus("couchage", null)}
          onReopen={() => setStatus("couchage", "sent")}
          receivedNode={<p className="rg-tiny" style={{ margin: 0, color: "#2f7a43" }}>Choix reçu : <b>{couchageLabel || "—"}</b></p>}
        />
      )}
    </>
  );
}
